export default "__VITE_ASSET__yvNeeO7u__"